import { ResourceModal } from '@app/components/Modal/ResourceModal';

import LabelInfoModalContent from '../LabelInfoModalContent';

interface LabelInfoModalProps {
  id: string;
  onClose: () => void;
}

export default function LabelInfoModal({ id, onClose }: LabelInfoModalProps) {
  return (
    <ResourceModal isOpen onRequestClose={onClose}>
      <LabelInfoModalContent id={id} onClose={onClose} />
    </ResourceModal>
  );
}
